import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './404.module.css';
import { Button } from '../../theme/button';  // Adjust path as needed

function Error404() {
  const navigate = useNavigate();

  return (
    <div className={styles.container}>
      <h1 className={styles.title}>404 - Page Not Found</h1>
      <p className={styles.message}>Sorry, we couldn’t find what you’re looking for.</p>
      <Button onClick={() => navigate('/')} style={{ width: '65%', height: 50 }}>
        Go to Home
      </Button>
    </div>
  );
}

export default Error404;
